import { createActionGroup } from '@ngrx/store';

export const DroitActions = createActionGroup({
  source: 'Droit',
  events: {}
});
